module.exports = __webpack_public_path__ + "img/社区服务站.ee0c92c2.png";